


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { IFieldMenuAction } from '@/fields/context-menu/types/field-menu-action';
import { EFieldMenuActionType } from '@/fields/context-menu/types/enums/field-menu-action-type';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class FieldContextMenuActions extends Vue {
  @Prop() actions: IFieldMenuAction[];
  @Prop() selectedActionType: EFieldMenuActionType;
  @Prop() flipped: boolean;

  EFieldMenuActionType = EFieldMenuActionType;

  showTextSize(textSize: number): boolean {
    return textSize && textSize != 0;
  }

  getDescription(action: IFieldMenuAction): string {
    const tooltip: string = action.description || action.name;
    return this.$t(tooltip).toString();
  }

  handleSelect(actionType: EFieldMenuActionType) {
    this.$emit('selectActionType', actionType);
  }

  handleOpen() {
    this.$emit('open');
  }
}
